import { EventEmitter } from 'events';

import { theme } from '../../constants/defaults';
import {
  cartAddItems,
  cartFetch,
  cartRemoveItem,
  cartUpdateItem,
  cartUpdateNote,
  cartPageFetch,
  cartTableFetch,
  cartTotalSummaryFetch,
} from './api';

export default class Cart extends EventEmitter {
  getState() {
    return cartFetch().then((state) => {
      this.updateCartCount(state.item_count);
      return state;
    });
  }

  getCartPage() {
    return cartPageFetch().then((cartContent) => cartContent);
  }

  getCartTable() {
    return cartTableFetch().then((cartContent) => cartContent);
  }

  getCartTotalSummary() {
    return cartTotalSummaryFetch().then((cartContent) => cartContent);
  }

  // Accepts array of items or object of 1 item
  // Item consists of id & quantity, properties are optional
  addItems(items) {
    this.emit('adding');

    let data = items;
    if (!Array.isArray(items)) {
      data = [items];
    }

    cartAddItems(data)
      .then(() => {
        if (theme.settings.ajaxCartEnabled) {
          // Open ajax cart
          // will update the cart count as well
          const modalNamespace = 'cart-modal';
          const modal = window.modalManager.idModalMap.get(modalNamespace);
          modal.show();
        } else {
          // Update cart count
          this.getState();
        }

        // Send added event
        this.emit('added');
      })
      .catch((response) => {
        response.json().then((error) => {
          this.emit('error_add_item', error);
        });
      });
  }

  async updateItem(key, options) {
    this.emit('updating');

    return cartUpdateItem(key, options)
      .then(
        (state) =>
          this.getCartTable()
            .then((cartTable) =>
              this.getCartTotalSummary()
                .then((cartSummary) => {
                  // this.updateCartCount(state.item_count);
                  this.emit('updated', state, cartTable, cartSummary);
                  this.updateCartCount(state.item_count);
                })
                .catch((error) => {
                  this.emit('error_update_item', error);
                }),
            )
            .catch((error) => {
              this.emit('error_update_item', error);
            }),

        // this.emit('updated', state, cartPage);
      )
      .catch((error) => {
        this.emit('error_update_item', error);
      });
  }

  async removeItem(key) {
    this.emit('removing');

    return cartRemoveItem(key)
      .then((state) => {
        this.updateCartCount(state.item_count);

        // Send updated event to trigger cart update
        this.emit('updated', null, state);
      })
      .catch((error) => {
        this.emit('error_remove_item', error);
      });
  }

  async updateNote(note) {
    return cartUpdateNote(note).catch((error) => {
      this.emit('error_update_note', error);
    });
  }

  updateCartCount(itemCount) {
    [...document.querySelectorAll('.js-cart-count')].forEach((cartCountEl) => {
      cartCountEl.innerHTML = itemCount;
    });
  }

  static getInstance() {
    if (!Cart.instance) {
      Cart.instance = new Cart();
    }
    return Cart.instance;
  }
}
